import { MINOR_UNITS } from "@platform/domain";
import { z } from "zod";
/** Each currency's minor digits (ISO 4217), which clients use to read and write amounts: 2 for SGD, 0 for JPY. */
export { MINOR_UNITS };
const currencies = Object.keys(MINOR_UNITS);
export const CurrencyCode = z.enum(currencies).meta({ id: "Currency", description: "ISO 4217 code" });
/** Money on the wire: integer minor units as a decimal string, never a float (contracts section 2). */
export const Money = z
    .object({
    amountMinor: z
        .string()
        .regex(/^-?(0|[1-9]\d*)$/)
        .describe("Integer amount in the currency's minor units, as a decimal string"),
    currency: CurrencyCode,
})
    .meta({ id: "Money", description: "An amount in integer minor units of one currency" });
//# sourceMappingURL=money.js.map